import React from 'react';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';

import { Typography } from '@material-ui/core';

import { getNumberOfFilteredProducts } from '../../../redux/slices/categoryDataSlice';

const FilterControls = () => {
	const numberOfFilteredProducts = useSelector(getNumberOfFilteredProducts);
	const { t } = useTranslation();

	return (
		<Typography variant="body2" color="textSecondary">
			{t('main:components.filtersPanel.productsStatus.matchingProducts') + numberOfFilteredProducts}
		</Typography>
	);
};

export default FilterControls;
